export const IconToggleHover = (props) => {
  return (
    <svg
      xmlns="http://www.w3.org/2000/svg"
      width="26"
      height="24"
      viewBox="0 0 26 24"
      fill="none"
    >
      <path
        d="M0.999999 3L1 21C1 22.1046 2.34315 23 4 23L22 23C23.6569 23 25 22.1046 25 21L25 3C25 1.89543 23.6569 1 22 1L4 1C2.34314 1 0.999999 1.89543 0.999999 3Z"
        stroke="#245cea"
        stroke-width="1.6"
        stroke-linecap="round"
        stroke-linejoin="round"
      />
      <path
        d="M0.999999 3L1 21C1 22.1046 1.95139 23 3.125 23L15.875 23C17.0486 23 18 22.1046 18 21L18 3C18 1.89543 17.0486 0.999999 15.875 0.999999L3.125 1C1.95139 1 0.999999 1.89543 0.999999 3Z"
        fill="#245cea"
        stroke="#245cea"
        stroke-width="1.6"
        stroke-linecap="round"
        stroke-linejoin="round"
      />
      <path
        d="M18 23L18 1"
        stroke="#245cea"
        stroke-width="1.6"
        stroke-linecap="round"
        stroke-linejoin="round"
      />
      <path
        d="M5.70573 12.5L13.2891 12.5"
        stroke="white"
        stroke-width="1.5"
        stroke-linecap="round"
        stroke-linejoin="round"
      />
      <path
        d="M9.4974 8.70573L13.2891 12.4974L9.4974 16.2891"
        stroke="white"
        stroke-width="1.5"
        stroke-linecap="round"
        stroke-linejoin="round"
      />
    </svg>
  );
};
